import { render, staticRenderFns } from "./VehicleModelDropdown.vue?vue&type=template&id=04f8272c"
import script from "./VehicleModelDropdown.vue?vue&type=script&lang=js"
export * from "./VehicleModelDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports